module.exports = __webpack_public_path__ + "static/media/logo-white.849cca31.png";